import getFunctionData from "../../../utils/get-function-data";

/**
 * Get global or local variable data
 * @param {String} input
 * @param {Map<String, [MainClassProps, String]>} variables
 * @param {Map<String, [MainClassProps, String]>} storage
 * @param {MainClassProps} main
 * @param {Boolean} global
 */
const getVariableData = (input, variables, storage, main, global) => {
  const prefix = global ? "$$" : "$";
  const index = global ? 2 : 1;
  const pure = input.slice(index);
  const data = getFunctionData(pure);
  const name = `${prefix}${data.get("name")}`;
  const value = /** @type {String} */ (data.get("parameters"));

  storage.set(name, [main, value]);
  variables.set(name, [main, value]);
};

export default getVariableData;
